import { Component } from '@angular/core';

@Component({
  selector: 'app-ventilation-source',
  templateUrl: './ventilation-source.component.html',
  // styleUrls: ['./ventilation-source.component.scss']
})
export class VentilationSourceComponent {
  isEdit = true;
  private _VentilationDetails: any = {
    mechanicalVentDatabase: false,
    mechanicalVentIndexNumber: 0,
    wetRoomsCount: 0,
    mechanicalVentMeasuredInstallation: false,
    mechanicalVentApprovedInstallation: false,
    mechanicalVentKitchenRoomFans: 0,
    mechanicalVentNonKitchenRoomFans: 0,
    mechanicalVentKitchenDuctFans: 0,
    mechanicalVentNonKitchenDuctFans: 0,
    mechanicalVentKitchenWallFans: 0,
    mechanicalVentNonKitchenWallFans: 0,
  };
  ventilationTypes = [
    'natural',
    'mechanical ventilation without heat recovery (MV)',
    'mechanical extract, decentralised (MEV dc)',
    'mechanical extract, centralised (MEV c)',
    'mechanical ventilation with heat recovery (MVHR)',
    'positive input from loft',
    'positive input from outside'
  ];
  ventDuctType = ['flexible', 'rigid', 'semi-rigid'];
  ventDuctPlacement = ['inside heated envelope', 'outside heated envelope'];
  ventDuctInsulation = ['not insulated', 'insulated'];
  ventDuctInsulationLevel = ['level 1', 'level 2'];

  get VentilationDetails(): any {
    return this._VentilationDetails;
  }
  

  set VentilationDetails(value: any) {
    this._VentilationDetails = {
      ...value,
      mechanicalVentDatabase: value.mechanicalVentDatabase ?? false,
      mechanicalVentIndexNumber: value.mechanicalVentIndexNumber ?? 0,
      wetRoomsCount: value.wetRoomsCount ?? 0,
      mechanicalVentMeasuredInstallation: value.mechanicalVentMeasuredInstallation ?? false,
      mechanicalVentApprovedInstallation: value.mechanicalVentApprovedInstallation ?? false,
      mechanicalVentKitchenRoomFans: value.mechanicalVentKitchenRoomFans ?? 0,
      mechanicalVentNonKitchenRoomFans: value.mechanicalVentNonKitchenRoomFans ?? 0,
      mechanicalVentKitchenDuctFans: value.mechanicalVentKitchenDuctFans ?? 0,
      mechanicalVentNonKitchenDuctFans: value.mechanicalVentNonKitchenDuctFans ?? 0,
      mechanicalVentKitchenWallFans: value.mechanicalVentKitchenWallFans ?? 0,
      mechanicalVentNonKitchenWallFans: value.mechanicalVentNonKitchenWallFans ?? 0,
      ventilationType: value.ventilationType ?? '',
      mechanicalVentDuctType: value.mechanicalVentDuctType ?? '',
      mechanicalVentDuctPlacement: value.mechanicalVentDuctPlacement ?? '',
      mechanicalVentDuctInsulation: value.mechanicalVentDuctInsulation ?? '',
      mechanicalVentDuctInsulationLevel: value.mechanicalVentDuctInsulationLevel ?? '',
    };
  }

}
